import {ReactElement} from 'react'
import CloseIcon from '@material-ui/icons/Close'
import {Trans} from 'react-i18next'

import messages from '../../../../../../../assets/messages'
import {ModalHeader} from '../../../../../../App/PopupFactory/popups/components/shared/ModalHeader'
import {useStyles} from './styles'
import {Button} from '@material-ui/core'

type OtherRefundIssueContentProps = {
  onClose: () => void
}

const SUPPORT_EMAIL = 'support@tauromarkets.com'

function OtherRefundIssueContent(props: OtherRefundIssueContentProps): ReactElement {
  const classes = useStyles()
  const {onClose} = props

  const handleClickChat = () => {
    window.LC_API?.open_chat_window()
  }

  return (
    <>
      <ModalHeader>
        <CloseIcon className={classes.closeIcon} onClick={onClose} />
        <div className={classes.title}>
          <Trans {...messages.contactSupport} />
        </div>
      </ModalHeader>
      <div className={classes.body}>
        <div className={classes.textTitle}>
          <Trans {...messages.viaEmail} />
        </div>
        <div className={classes.text}>
          <Trans
            {...messages.sendUsEmail}
            values={{email: SUPPORT_EMAIL}}
            components={[<a className={classes.link} href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>]}
          />
        </div>
        <div className={classes.textTitle}>
          <Trans {...messages.liveChat} />
        </div>
        <div className={classes.text}>
          <Trans {...messages.liveChatText} />
        </div>
        <Button className={classes.button} color='primary' variant='contained' fullWidth onClick={handleClickChat}>
          <Trans {...messages.chatWithAnAgent} />
        </Button>
      </div>
    </>
  )
}

export {OtherRefundIssueContent}
